import playStore from './../../../../website/assets/images/googlePlay-white.png';
import { Link } from "react-router";

export default function Hero() {
  return (
    <section class="hero">
      <div class="hero-content">
        {/* <h5 class="subtitle">Power. Passion. Performance.</h5> */}
        <h1 className='tagLine'>Fuel Your Freedom</h1>
        <h2 className='tagLine'>Your Ultimate Bike Experience</h2>
        <Link to="/how-motourax-works">
          <button class="btn">
            Explore Now
          </button>
        </Link>
        <div class="app-download">
          {/* <a href="https://play.google.com/store/apps/details?id=your.android.app" target="_blank">
        <img src={playStore} alt="Get it on Google Play" class="app-store-icon"/>
      </a> 
          <a href="https://apps.apple.com/us/app/your-ios-app" target="_blank">
        <img src="https://upload.wikimedia.org/wikipedia/commons/6/6f/Apple_App_Store_icon.svg" alt="Download on the App Store" class="app-store-icon"/>
      </a>  */}
        </div>
      </div>
    </section>
  );
}